import Loader from './components/Loader';

export default Loader